import ClientSettingsProvider from "context/admin/client-settings";
import SettingsContent from "page_components/admin/clients/Settings";

const Settings = () => (
  <ClientSettingsProvider>
    <SettingsContent />
  </ClientSettingsProvider>
);

export default Settings;
